import { render, staticRenderFns } from "./PrizeOrder.vue?vue&type=template&id=257d90cf&scoped=true&"
import script from "./PrizeOrder.vue?vue&type=script&lang=js&"
export * from "./PrizeOrder.vue?vue&type=script&lang=js&"
import style0 from "./PrizeOrder.vue?vue&type=style&index=0&id=257d90cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d90cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257d90cf')) {
      api.createRecord('257d90cf', component.options)
    } else {
      api.reload('257d90cf', component.options)
    }
    module.hot.accept("./PrizeOrder.vue?vue&type=template&id=257d90cf&scoped=true&", function () {
      api.rerender('257d90cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/PrizeOrder/PrizeOrder.vue"
export default component.exports